import { useSelector } from "react-redux";
import { useParams } from "react-router-dom"
import { OPEN_PROJECT_ID } from "../config/constant/curatorConstants";
import { selectCalculatedRoomId, selectRoomId } from "../redux/slicers/admin/curatorSlicer";

export const useCuratorData = () => {
  const { type, room_id } = useParams();
  const curatorRoomId = useSelector(selectRoomId)
  const calculatedRoomId = useSelector(selectCalculatedRoomId);
  const isOpenProjectFlow = room_id === OPEN_PROJECT_ID;
  const isRoom = type === 'room';
  const isNewProjectFlow = type === 'room' && !isOpenProjectFlow;

  return {
    type,
    roomId: type === 'project' ? room_id : curatorRoomId,
    isOpenProjectFlow,
    isRoom,
    isProject: type === 'project',
    isNewProjectFlow,
    isNewProject: isNewProjectFlow,
    projectId: type === 'project' ? room_id : undefined,
    calculatedRoomId,
  }
}